/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const contactTranslations = {
  email: {
    label: "E-Mail-Adresse",
  },
  telephone: {
    label: "Telefonnummer",
  },
  fax: {
    label: "Faxnummer",
  },
  contactTime: {
    label: "Wann können wir Sie telefonisch erreichen?",
    options: {
      8: {
        label: "8 Uhr",
      },
      9: {
        label: "9 Uhr",
      },
      10: {
        label: "10 Uhr",
      },
      11: {
        label: "11 Uhr",
      },
      12: {
        label: "12 Uhr",
      },
      13: {
        label: "13 Uhr",
      },
      14: {
        label: "14 Uhr",
      },
      15: {
        label: "15 Uhr",
      },
      16: {
        label: "16 Uhr",
      },
      17: {
        label: "17 Uhr",
      },
      18: {
        label: "18 Uhr",
      },
      flexible: {
        label: "Ich bin flexibel",
      },
    },
  },
};

export default contactTranslations;
